module.exports = __webpack_public_path__ + "static/media/19-15.6149113a.mp3";